import { useState, useEffect } from 'react';

const useStoreData = (store, entities, options) => {
  const [data, setData] = useState(store.getDataOrLoad(entities));
  useEffect(() => {
    const subscription = store.subscribe(
      entities,
      (res) => {
        setData(res);
      },
      options,
    );
    return () => {
      if (subscription) {
        store.unsubscribe(subscription);
      }
    };
  }, []);
  return data;
};

export default useStoreData;
